import { Table } from "antd";
import { useIntl } from "react-intl";
import MailContentModal from "./MailContentModal/MailContentModal";
import "./MessageHistoryTable.less";

function usePreparedTableData(messageHistory, intl) {
   const excludedKeys = ["mailBoxId", "instanceId"];

   const columns = messageHistory.length
      ? Object.keys(messageHistory[0])
           .filter((key) => !excludedKeys.includes(key) && key !== "textPlain")
           .map((key, index) => ({
              title: intl.formatMessage({ id: `actionsColumn.${key}` }),
              dataIndex: key,
              key: key + index,
              className: "message-actions-table__cell",
              width: key === "textHtml" ? 200 : "auto"
           }))
      : [];

   const rows = messageHistory.map((action) => {
      const filteredAction = Object.keys(action)
         .filter((key) => !excludedKeys.includes(key))
         .reduce((obj, key) => {
            obj[key] = action[key];
            return obj;
         }, {});
      return filteredAction;
   });

   return { columns, rows };
}

const MessageHistoryTable = ({ messageHistory }) => {
   const intl = useIntl();

   const { columns, rows } = usePreparedTableData(messageHistory, intl);

   const adjustedRows = rows.map((row) => {
      if (row.textHtml || row.textPlain) {
         row.textHtml = <MailContentModal content={row.textHtml || row.textPlain} />;
      }
      return row;
   });

   return (
      <Table
         className="message-history-table"
         columns={columns}
         dataSource={adjustedRows}
         bordered={true}
         pagination={{
            className: "message-history-table__pagination"
         }}
      />
   );
};

export default MessageHistoryTable;
